import React, { useEffect, useState } from "react";
import styles from "./journey.module.css";
import StarContainer from "../../components/star-container/star-container";
import Header from "../../components/header/header";
import ScrollUpButton from "../../components/buttons/scroll-up-button/scroll-up-button";
import Footer from "../../components/footer/footer";
import {
    selectJourneyEntities,
    selectJourneyFilter,
    selectJourneyTab,
    selectVisibleJourneyIds,
} from "../../store/selectors/journeySelectors";
import { useDispatch, useSelector } from "react-redux";
import { changeDifficulty, changeTab } from "../../store/reducers/list/journeyList";
import SearchBox from "../../components/search-box/search-box";
import Checkbox from "../../components/checkbox/checkbox";
import JourneyEventInfo from "../../components/journey/journey-event-info";
import { selectArcanaEntities, selectArcanasByEventQuery } from "../../store/selectors/arcanaSelectors";
import ArcanaEventInfo from "../../components/journey/arcana-event-info";
import FilterSelect from "../../components/filter-select/filter-select";
import { getUIText } from "../../translation";
import { LOCALES } from "../../constants";
import { loadData } from "../../functions/dataLoader";
import FILTERS from "../../config/filter_config.json";

export default function Journey() {
    const theme = useSelector((state) => state.theme.value);
    const lang = useSelector((state) => state.lang.value);

    // const arcanas = useSelector((state) => state.arcanas.value);

    // const [FILTERS, setFILTERS] = useState(null);

    // useEffect(() => {
    //     loadData("filter_config.json").then(setFILTERS);
    // }, []);

    const [showArcana, setShowArcana] = useState(true);
    const [showJourney, setShowJourney] = useState(true);
    const [query, setQuery] = useState("");

    const journeyIds = useSelector((state) => selectVisibleJourneyIds(state, query));
    const journeyEntities = useSelector((state) => selectJourneyEntities(state));
    const filter = useSelector((state) => selectJourneyFilter(state));
    const arcanaIds = useSelector((state) => selectArcanasByEventQuery(state, query));
    const arcanaEntities = useSelector((state) => selectArcanaEntities(state));

    const dispatch = useDispatch();

    // if (!FILTERS) return;

    const tabGroup = lang === LOCALES.KO ? FILTERS.JOURNEY_GROUP : FILTERS.JOURNEY_GROUP_ENG;

    return (
        <div id="container" data-theme={theme} data-lang={lang}>
            {theme === "dark" && <StarContainer />}
            <Header title={getUIText(lang, "header.title.journey")} />

            <div className={styles["journey-container"]}>
                <div className={styles["search-box-wrapper"]}>
                    <FilterSelect
                        id={"journey_difficulty"}
                        list={lang === LOCALES.KO ? FILTERS.JOURNEY_DIFFICULTY : FILTERS.JOURNEY_DIFFICULTY_ENG}
                        selected={filter.difficulty}
                        changeFilter={changeDifficulty}
                        forceWidth={"100px"}
                    />
                    <SearchBox changeQuery={setQuery} placeholder={getUIText(lang, "search.journey")} />
                </div>
                <div className={styles["checkboxes"]}>
                    <Checkbox
                        value={showArcana}
                        setValue={() => setShowArcana(!showArcana)}
                        text={getUIText(lang, "check.journey.showArcana")}
                    />
                    <Checkbox
                        value={showJourney}
                        setValue={() => setShowJourney(!showJourney)}
                        text={getUIText(lang, "check.journey.showJourney")}
                    />
                </div>
                {/* is require to make this to a component? */}
                {query === "" && (
                    <div className={styles["tabs"]}>
                        {tabGroup.map((group) => {
                            return (
                                <button
                                    type="button"
                                    className={`${styles["tab-button"]} ${group.value === filter.tab.value ? `${styles["active"]}` : ""}`}
                                    onClick={() => dispatch(changeTab(group))}
                                    key={group.name}
                                >
                                    {group.name}
                                </button>
                            );
                        })}
                    </div>
                )}
                <div className={styles["legends"]}>
                    {/* <div className={`${styles["legend"]}`}>
                        <div className={styles["box"]} />
                        고정 보상
                    </div> */}
                    <div className={`${styles["legend"]} ${styles["success"]}`}>
                        <div className={styles["box"]} />
                        {getUIText(lang, "journey.legends.success")}
                    </div>
                    <div className={`${styles["legend"]} ${styles["fail"]}`}>
                        <div className={styles["box"]} />
                        {getUIText(lang, "journey.legends.failed")}
                    </div>
                </div>
                <div className={styles["journey-info-wrapper"]}>
                    {query !== "" &&
                        showArcana &&
                        arcanaIds.map((id) => {
                            const arcana = arcanaEntities[id];
                            return <ArcanaEventInfo lang={lang} arcana={arcana} key={`arcana_${arcana.id}`} />;
                        })}
                    {(query === "" || showJourney) &&
                        journeyIds.map((id) => {
                            const journey = journeyEntities[id];
                            return <JourneyEventInfo lang={lang} journey={journey} difficultyFilter={filter.difficulty} key={id} />;
                        })}
                </div>
            </div>
            <ScrollUpButton />
            <Footer />
        </div>
    );
}
